module.exports = __webpack_public_path__ + "fonts/Kent4FPrintedShadowed.f61ec84.woff2";